import React from 'react';
// @flow

import isEmpty from 'lodash/isEmpty';
import I18n from 'PMT/i18n/I18n';

import HibpPasswordRangeContainer from 'PMT/components/HibpPasswordRangeContainer';

const HibpPassword = ({
  password,
  pwnedText,
  displayIsSecureMessage = true,
  displayCheckSecure = true,
  minPasswordLength = 8, // TODO: change to 8?
}) => (
  <HibpPasswordRangeContainer password={password}>
    {({ isPwned, isFetching }) => {
      if (isFetching) {
        if (displayCheckSecure) {
          return <p className="alert alert-info top-buffer-10">{I18n.tr('security.hibp.pwned.checking')}</p>;
        }
        return null;
      }

      if (isPwned) {
        return (
          <p className="alert alert-warning top-buffer-10">{pwnedText}</p>
        );
      }

      const isTooSmall =
        isEmpty(password) || password.length < minPasswordLength;
      if (displayIsSecureMessage && !isTooSmall) {
        return (
          <p className="alert alert-info top-buffer-10">
            {I18n.tr('security.hibp.pwned.is_secure')}
          </p>
        );
      }
      return null;
    }}
  </HibpPasswordRangeContainer>
);

export default HibpPassword;
